<p>
    <mat-toolbar class = "pl-bgc s-tc">

      <button   mat-icon-button 
                *ngIf   =   "drawer"
                (click) =   "toggleMenu()">

        <mat-icon>menu</mat-icon>

      </button>

      <span class="ml-3 " *ngIf="menuConf && menuConf.item" >
        {{ title }} 
      </span>

      <span class="spacer"></span>

      <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>account_circle</mat-icon>
      </button>

      <mat-menu #menu="matMenu">
        
        <button mat-menu-item (click)="changePassword()">
          <mat-icon>account_circle</mat-icon>
          <span translate>menu.settings.passwordchange</span>
        </button>
  
      </mat-menu>

      <button   mat-icon-button
                class   =   "ml-3"
                (click) =   "logout()">

        <mat-icon>exit_to_app</mat-icon>

      </button>

    </mat-toolbar>
  </p>